class ShareButtons {
  constructor() {
    this.$launchButton = document.querySelector('#launchShareButtons');
    this.$modal = document.querySelector('.mod-share-buttons');
    this.$overlay = document.querySelector('.overlay-share-buttons');
    this.$closeButton = document.querySelector('.mod-sb');
  }

  toggleModal() {
    this.$overlay.classList.toggle('show');
    this.$modal.classList.toggle('open');
  }

  bindEvents() {
    if (this.$launchButton) {
      this.$launchButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleModal();
      });
    }

    this.$overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleModal();
    });

    this.$closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleModal();
    });
  }
}

if (document.querySelector('.mod-share-buttons')) {
  window.shareButtonsModal = new ShareButtons();
  window.shareButtonsModal.bindEvents();
}

export default ShareButtons;
